import { Component, ComponentFactoryResolver } from "@angular/core";
import { SmallCardComponent } from "@app/home/cards/small-card/small-card.component";
import { SvgPharmacyComponent } from "@app/home/svg/svg-pharmacy/svg-pharmacy.component";
import { ConfigService } from "@app/core/config.service";
import { PatientPharmacy } from "@app/shared/patient-pharmacy";
import { HomePageAnalyticsService } from "@app/home/home-page-analytics.service";

@Component({
  selector: "om-pharmacy-card",
  templateUrl: "./small-card/small-card.component.html",
  styleUrls: ["./default-styling.scss", "./small-card/small-card.component.scss"],
})
export class PharmacyCardComponent extends SmallCardComponent {
  constructor(
    private config: ConfigService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private homePageAnalyticsService: HomePageAnalyticsService
  ) {
    super();
  }

  ngOnInit() {
    this.card = {
      svg: this.componentFactoryResolver.resolveComponentFactory(SvgPharmacyComponent),
      title: "Choose Pharmacy",
      link: `${this.config.json.myoneServer}/pt/my-one/pharmacy`,
    };

    this.homePageAnalyticsService.trackPreferredPharmacyLink("om-pharmacy-card a");

    let preferredPharmacy = this.user.patientPharmacies.find(
      (patientPharmacy: PatientPharmacy) => patientPharmacy.isPreferred
    );

    if (preferredPharmacy) {
      this.card.title = "Preferred Pharmacy";
      this.card.text = preferredPharmacy.pharmacy.displayName;
      this.card.details = preferredPharmacy.pharmacy.displayAddressStreet;
    }

    super.ngOnInit();
  }
}
